<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-list two-line>
          <template v-for="(item, index) in tours.items.items">
            <v-list-tile
              :key="item.id"
              avatar
              ripple
              @click="toggle(item, index)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.tourname }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ item.loadno }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{ item.driver.firstname + ' ' + item.driver.lastname + ', Gerät: ' + item.device }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>{{ item.kfz }}</v-list-tile-action-text>
                <v-icon
                  v-if="!item.tourfinished"
                  color="grey lighten-1"
                >
                  check_circle_outline
                </v-icon>

                <v-icon
                  v-else
                  color="green darken-2"
                >
                  check_circle
                </v-icon>
              </v-list-tile-action>

            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      selected: [2]
    };
  },
  computed: {
    tours() {
      return this.$store.state.tours.today;
    }
  },

  methods: {
    toggle(item, index) {
      const loadno = item.loadno;
      this.$emit('openSpecificTour', loadno);
    }
  }
};
</script>
